import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import "../../../entities/vehicle/api/api.js";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import "../../../entities/vehicle/model/selectors/selectVehicleParameters.js";
import "react-redux";
import "../../../features/benefitChoice/model/index.js";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import { useGetVehiclePrice } from "../../../entities/vehicle/lib/useGetVehiclePrice.js";
import "../../../features/filterValues/api/api.js";
import "../../../features/filterValues/model/middleware/index.js";
import "../../../features/filterValues/model/selectors/selectAllFilterValues.js";
import "../../../features/filterValues/model/selectors/selectAllFilterValuesParameters.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValues.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValuesParameters.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValuesQueries.js";
import "../../../features/filterValues/model/selectors/selectDependentFilterKeysByKey.js";
import "../../../features/filterValues/model/selectors/selectFilterImmutableQueries.js";
import "../../../features/filterValues/model/selectors/selectFilterImmutableValues.js";
import "../../../features/filterValues/model/selectors/selectFilterItemByKey.js";
import "../../../features/filterValues/model/selectors/selectFilterItems.js";
import "../../../features/filterValues/model/selectors/selectFilterValuesFields.js";
import "../../../features/filterValues/model/selectors/selectGroupedFilterItemByKey.js";
import "../../../features/filterValues/model/selectors/selectIsFilterValuesMissing.js";
import "@perxis-auto/shared";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import "../../../shared/store/installation/model/slice.js";
import "../../../shared/store/installation/middleware/index.js";
import "../../../entities/vehicle/model/selectors/selectIsVehiclesDataMissing.js";
import "../../../entities/vehicle/model/selectors/selectVehicle.js";
import "../../../entities/vehicle/model/selectors/selectVehicles.js";
import "../../../entities/vehicle/model/selectors/selectVehiclesCount.js";
import "../../../entities/vehicle/model/selectors/selectVehiclesParameters.js";
import "../../../entities/vehicle/model/selectors/selectVehiclesTotalPages.js";
import "../../../shared/context/constructor.js";
import { useThisContext, useLoadingContext } from "../../../shared/context/this.js";
import "@perxis-auto/shared/lib";
import { useMergedConstructorItemProps } from "../../../shared/lib/constructor/hooks/useMergedConstructorItemProps.js";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "@perxis-auto/ui-kit";
import { formatPrice } from "../../../shared/lib/format/formatPrice.js";
import { formatVehicleBenefits } from "../../../shared/lib/format/vehicle/formatVehicleBenefits.js";
import "../../../shared/lib/logger/index.js";
import "../../../shared/store/config/middleware/index.js";
import { selectBenefits } from "../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import "../../../shared/store/config/model/selectors/selectSort.js";
import "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
import { BenefitsTooltip } from "../../../shared/ui/benefitsTooltip/BenefitsTooltip.js";
import { GET_DEFAULT_CONTAINER_PROPS } from "../config/props.js";
const useContainer = (item) => {
  const {
    label,
    value: customPrice,
    oldValue: customOldPrice,
    oldValuePosition,
    postfix,
    prefix,
    ...props
  } = useMergedConstructorItemProps(item, GET_DEFAULT_CONTAINER_PROPS);
  const vehicleItem = useThisContext();
  const isLoading = useLoadingContext();
  const { enable, showOnlyBlock, tooltipTitle } = useAppSelector(selectBenefits);
  const { price, oldPrice } = useGetVehiclePrice(vehicleItem, { withoutSelectedBenefits: true });
  const resolvedPrice = customPrice || price;
  const formattedPrice = formatPrice(resolvedPrice, prefix, postfix);
  const resolvedOldPrice = customOldPrice || oldPrice;
  const formattedOldPrice = formatPrice(resolvedOldPrice, prefix, postfix);
  const isBenefitsEnabled = enable && !showOnlyBlock;
  const benefits = useMemo(() => vehicleItem ? formatVehicleBenefits(vehicleItem) : null, [vehicleItem]);
  const isDisplayBenefitsTooltip = isBenefitsEnabled && benefits && benefits.length > 0;
  const isDisplayOldPrice = isBenefitsEnabled && resolvedPrice !== resolvedOldPrice;
  const tooltipContent = useMemo(() => {
    if (!benefits || !resolvedOldPrice) {
      return;
    }
    return /* @__PURE__ */ jsx(BenefitsTooltip.Content, { benefits, carPrice: resolvedOldPrice });
  }, [benefits, resolvedOldPrice]);
  const priceSection = useMemo(
    () => ({
      currentValue: formattedPrice,
      oldValue: isDisplayOldPrice ? formattedOldPrice : void 0,
      oldValuePosition
    }),
    [formattedOldPrice, formattedPrice, isDisplayOldPrice, oldValuePosition]
  );
  const benefitsSection = useMemo(
    () => ({
      hidden: !isDisplayBenefitsTooltip,
      tooltipContent,
      tooltipTitle: /* @__PURE__ */ jsx(BenefitsTooltip.Title, { title: tooltipTitle })
    }),
    [isDisplayBenefitsTooltip, tooltipContent, tooltipTitle]
  );
  const additionsSection = useMemo(() => {
    if (!label) {
      return;
    }
    return [
      {
        color: "dark-light",
        level: "super-small",
        children: label
      }
    ];
  }, [label]);
  return {
    ...props,
    price: priceSection,
    benefits: benefitsSection,
    additions: additionsSection,
    isLoading
  };
};
export {
  useContainer
};
